import axios from 'axios'
import EMAIL_REGEXP from './lib/validators'

const URL = process.env.NODE_ENV === 'development' ? 'http://homolog.seekr.com.br:3000' : window.location.origin

const request = axios.create({
  baseURL: URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

export function checkEmail(email, recaptchaResponse) {
  return request.post('/valid_email', {
    email: email,
    "g-recaptcha-response-data": recaptchaResponse,
  })
}

export function signin({ email, password, rememberMe, recaptchaResponse/* , reCAPTCHAToken */ }) {
  return request.post('/sign_in.json', {
    login: email,
    password,
    remember_me: rememberMe,
    "g-recaptcha-response-data": recaptchaResponse,
  })
}

export function signup(params) {
  return request.post('/sign_up', params)
}

export function forgotPassword(email, recaptchaResponse) {
  return request.post('/send_password_reset', {
    login: email,
    "g-recaptcha-response-data": recaptchaResponse,
  })
}

export function passwordReset(token, password, password_confirmation) {
  return request.post('/do_password_reset', {
    token,
    password,
    password_confirmation,
  })
}

export default request



// WEBPACK FOOTER //
// ./src/api.js